// Purpose: Centralized action button configurations for evidence display
// Audience: All evidence components that need consistent button behavior
// Features:
// - Standard button configurations for different contexts
// - Consistent icons and behavior
// - Easy to maintain and extend

import React from 'react';
import { FaShare, FaBolt } from 'react-icons/fa';

// Standard action button configurations
export const createCasefileEvidenceActions = (onOpenResults, onShare) => [
  {
    label: 'Share',
    icon: <FaShare />,
    variant: 'share',
    onClick: (e) => {
      e.stopPropagation();
      onShare && onShare();
    }
  },
  {
    label: 'Actions',
    icon: <FaBolt />,
    variant: 'actions',
    onClick: (e) => {
      e.stopPropagation();
      onOpenResults && onOpenResults();
    }
  }
];

export const createPublicEvidenceActions = (onOpenResults, onShare) => [
  // Public evidence allows viewing public results and actions
  {
    label: 'Share',
    icon: <FaShare />,
    variant: 'share',
    onClick: (e) => {
      e.stopPropagation();
      onShare && onShare();
    }
  },
  {
    label: 'Actions',
    icon: <FaBolt />,
    variant: 'actions',
    onClick: (e) => {
      e.stopPropagation();
      onOpenResults && onOpenResults();
    }
  }
];

export const createModalEvidenceActions = (onOpenResults, onShare) => [
  {
    label: 'Share',
    icon: <FaShare />,
    variant: 'share',
    onClick: () => {
      onShare && onShare();
    }
  },
  {
    label: 'Actions',
    icon: <FaBolt />,
    variant: 'actions',
    onClick: () => {
      onOpenResults && onOpenResults();
    }
  }
];

// Context-aware action button generator
export const getEvidenceActions = (context, handlers = {}) => {
  switch (context) {
    case 'casefile':
      return createCasefileEvidenceActions(
        handlers.onOpenResults, 
        handlers.onShare
      );
    case 'public':
      return createPublicEvidenceActions(
        handlers.onOpenResults,
        handlers.onShare
      );
    case 'modal':
      return createModalEvidenceActions(
        handlers.onOpenResults,
        handlers.onShare
      );
    default:
      return [];
  }
};